import { language } from '@comall-backend-builder/core/lib/services';

var BooleanFormat = function () {
  function BooleanFormat() {}
  /**
   * 对数据进行校验
   */


  BooleanFormat.prototype.validate = function (_rule, value, callback) {
    if (value && typeof value !== 'boolean') {
      callback(language.getText('validation.boolean.default'));
    } else {
      callback();
    }
  };
  /**
   * 将数据转换为 boolean 类型的值
   * 对于非 boolean 值，遵循如下规则：
   * - undefined, null - 转换为 undefined
   * - 任何其它值，都转换为 true
   */


  BooleanFormat.prototype.format = function (value) {
    if (typeof value === 'boolean') {
      return value;
    } else if (value == null) {
      return undefined;
    } else {
      return true;
    }
  };
  /**
   * 将数据格式化为请求参数
   */


  BooleanFormat.prototype.formatParams = function (key, value) {
    var _a;

    return _a = {}, _a[key] = value, _a;
  };

  return BooleanFormat;
}();

export { BooleanFormat };